import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  TextField,
  Box,
  Stack,
  Grid,
  MenuItem,
  Modal,
  InputAdornment,
} from "@mui/material";
import { SvgIcon } from "@mui/material";
import "../Styles/AdminListings.css";
import { careUsersColumns,exportCareFacilityUserColumns } from "./careUsersColumns";
import ActiveCounts from "../common/ActiveCounts";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useSelector, useDispatch } from "react-redux";
import {
  getCareFacilityList,
  getClientUsersList,
  deleteClientUser,
  handleResendEmailForPwdReset,
  clientUserListReport,
} from "../../common/constants/globalconstants";
import { updateActiveCounts } from "../../../action";
import { exportToExcel, maskedAccountId } from "../../common/Utils";
import { Check, Search } from "@mui/icons-material";
import { CustomExcelExport } from "../../common/CustomExcelExport";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";

//#F2F3F5 alternate color

const customStyle = {
  table: {
    style: {
      border: "1px solid #DEDEDE",
      borderRadius: "5px",
    },
  },
  header: {
    style: {
      color: "#193062",
      textAlign:"center"
    },
  },
  headRow: {
    style: {
      border: "none",
      backgroundColor: "#CDD4DC",
      fontWeight: "bold",
      color: "#002d82",
      fontSize: "14px",
      whiteSpace: "unset",
      textAlign:"center"
    },
  },
  rows: {
    stripedStyle: {
      backgroundColor: "#F2F3F5",
    },
  },
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

function CareFacilityUsersListings() {
  const [careFacilityEmail, setCareFacilityEmail] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { action } = useParams();
  const [records, setRecords] = useState([]);
  const [userAndCareFacilityData, setUserAndCareFacilityData]= useState([]);
  const [originalData, setOriginalData]= useState([]);
  const [clientUsers, setClientUsers] = useState([]);
  const [facilityRecords, setFacilityRecords] = useState([]);
  const [accountNum, setAccountNum] = useState("");
  const [careFacility, setCareFacility] = useState("");
  const [careFacilityId, setCareFacilityId] = useState("");
  //const [defaultCareFacilityId, setDefaultCarefacilityId] =useState(-1);
  const [loading, setloading] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false); //to be deleted
  const [deleteRow, setDeleteRow] = useState({});
  const [userName, setUserName] = useState("");
  const [resetPagination, setRstPagination] = useState(false);
  const storeUser = useSelector((state) => state.storeuser);
  const userAccessRole = useSelector((state) => state.userAccessRole);
  const [refreshOpen, setRefreshOpen] = useState(false);
  const [refreshMsg, setRefreshMsg] = useState("");
  const [searchField, setSearchField] = useState("");
  const [errormodalopen, seterrormodalOpen] = useState(false);
  const [disableBtns, setDisableBtns] = useState(false);
  const [idsListForDownload, setIdsListForDownload] = useState([]);
  const defaultValue = {          
    accountNumber: "",
    address: "",
    companyName: "------------Select------------",
    city: "",
    contactPerson: "",
    createdBy: "",
    email: "",
    id: -1,
    numberOfUsers: 0,
    state: "",
    telephoneNum: "",
    zip: "",
}

  useEffect(() => {
    fetchCareFacilityDetails();
  }, []);

  const fetchCareFacilityDetails = async(btnClick) => {
    try{
    setloading(true);
    const resp = await axiosInstance.get(`${getCareFacilityList}`);
     if(resp.data.isSuccess) {
        let list = resp.data.result.careFacilityList;
        
        let updatedCarefacilityList = [defaultValue, ...list];
        if(resp.data.result!== null && resp.data.result.careFacilityList) {
          //setFacilityRecords(resp.data.result.careFacilityList);
          updatedCarefacilityList = updatedCarefacilityList.filter((item)=> item.isStandAlone === "YES" || item.isChild === "YES");
          updatedCarefacilityList = [defaultValue, ...updatedCarefacilityList];
          setFacilityRecords(updatedCarefacilityList);
        }
        if ((action == undefined && btnClick != "delete") || btnClick == "reset" || action == "viewAll") {         
          setCareFacility(updatedCarefacilityList[0].companyName);
          setAccountNum(updatedCarefacilityList[0].accountNumber);
          setCareFacilityId(updatedCarefacilityList[0].id);
          setCareFacilityEmail(updatedCarefacilityList[0].email);
        }
        if(btnClick == "delete" && careFacility!=="------------Select------------"){
          const selectedItem = facilityRecords.filter(
            (item) => item.companyName == deleteRow.careFacilityName
          );
          setAccountNum(selectedItem[0].accountNumber);
          setCareFacility(selectedItem[0].companyName);
          setCareFacilityId(selectedItem[0].id);
          setCareFacilityEmail(selectedItem[0].email);
        }
        const { numberofActiveUsers, numberofCareFaclities } = resp.data.result;
        dispatch(
          updateActiveCounts({ numberofActiveUsers, numberofCareFaclities })
        );
      }

      else if(!resp.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
      }
      catch(err) {
        setloading(false);
        console.log(err.message);
        seterrormodalOpen(true);
    }
  };

  useEffect(() => {
    if (action == "view") {
      setCareFacility(location.state.companyName);
      setAccountNum(location.state.accountNumber);
      setCareFacilityId(location.state.id);
      setCareFacilityEmail(location.state.email);
      getUsersList(location.state.id);      
    }
  }, [action]);

  useEffect(() => {
    if(action != "view"){
     fetchClientUsersList("All", 0);
    }
  }, []);


  const getUserAndCfDataForDownload = async() =>{
    try{
      const request = {
        clientUserIdList: idsListForDownload
      }
      const resp = await axiosInstance.post(`${clientUserListReport}`, JSON.stringify(request));
       if(resp.data.isSuccess) {
          setUserAndCareFacilityData(resp.data.result);
          exportToExcel(exportCareFacilityUserColumns, resp.data.result, "CareFacilityUser-Listings.xlsx" );
          //setIdsListForDownload([]);
       }
       else if(!resp.data.isSuccess){
          seterrormodalOpen(true);
        }
        }
        catch(err) {
            setloading(false);
            seterrormodalOpen(true);
            console.log(err.message)
      };
  }

  const getUsersList= async(id)=>{
    try{
    setloading(true);
    const resp = await axiosInstance.get(`${getClientUsersList}?careFacilityId=${id}`);
     if(resp.data.isSuccess) {
          setRecords(resp.data.result);
          setOriginalData(resp.data.result);
          setClientUsers(resp.data.result);
          setloading(false);
     }
     else if(!resp.data.isSuccess){
            seterrormodalOpen(true);
          }
      }
      catch(err) {
          setloading(false);
          seterrormodalOpen(true);
          console.log(err.message)
    };
  }

  const fetchClientUsersList = async(loadType, id) => {
    //if (careFacility != "" && accountNum != "") {
    try{
    setloading(true);
    let resp;
    if(loadType === "All" || loadType === "OnDelete"){
       resp = await axiosInstance.get(`${getClientUsersList}`);
    }
    else if(id !== 0){
       resp = await axiosInstance.get(`${getClientUsersList}?careFacilityId=${id}`);
    }
    else{
      resp = await axiosInstance.get(`${getClientUsersList}?careFacilityId=${careFacilityId}`);
    }
    
        if(resp.data.isSuccess){
          //success fetching data
          setRecords(resp.data.result);
          setOriginalData(resp.data.result);
          setClientUsers(resp.data.result); 
          if(id!==0){
            getClientUserIds(resp.data.result);
          }
        }
        else if(!resp.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
      }
      catch(err) {
          setloading(false);
          seterrormodalOpen(true);
          console.log(err.message)
      }
  };


  const onChangeFacility = (e) => {
    setSearchField("");
    const selectedItem = facilityRecords.filter(
      (item) => item.companyName === e.target.value
    );
    setAccountNum(selectedItem[0].accountNumber);
    setCareFacility(selectedItem[0].companyName);
    setCareFacilityId(selectedItem[0].id);
    setCareFacilityEmail(selectedItem[0].email);
    fetchClientUsersList("OnSelect", selectedItem[0].id);
  };

  {/*const handleRefreshStatus = (row) => {
    try {
      const clientUserData = {
        userName: row.userName.toLocaleLowerCase(),
        createdBy: storeUser.email,
        clientUserId: row.id
      };
      setloading(true);
      axios
        .post(
          `${baseurl}${updateClientUserStatus}`,
          JSON.stringify(clientUserData),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${storeToken}`,
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            const msg = response.data.Message;
            if (msg.indexOf(":") !== -1) {
              const respValue = msg.split(":")[1];
              setRefreshMsg(msg.split(":")[0]);
              if (respValue === "true") {
                //fetchClientUsersList();
                setRefreshOpen(false);
              } else {
                setRefreshOpen(true);
              }
              fetchClientUsersList();
            }
          }
          else if(response.data.isSuccess){
            seterrormodalOpen(true);
          }
          setloading(false);
        });
    } catch (error) {
      setloading(false);
      seterrormodalOpen(true);
      console.log(error);
    }
  };*/}

  const handleDelete = (row) => {
    setUserName(row.userName);
    setOpen(true);
    setDeleteRow(row);
    setDisableBtns(false);
  };

  const handleDeleteClientUser = async() => {   
  setDisableBtns(true);
    try{
    const clientUserData = {
      clientUserId: deleteRow.id,
      updatedBy: storeUser.email,
    };
    const response = await axiosInstance.delete(`${deleteClientUser}`, {
        data: clientUserData});
        if (response.data.isSuccess) {
          setDeleteOpen((preState) => !preState);
          setOpen((prevState) => !prevState);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
      }
      catch(err) {
        setloading(false);
        seterrormodalOpen(true);
        console.log(err.message)
    }
  };

  const handleDeleteClose = () => {
    setDisableBtns(false);
    setDeleteOpen(false);
    fetchClientUsersList("OnDelete", 0);
    fetchCareFacilityDetails("delete");
  };

  const handleResendEmail = async(row) =>{   
    try {
       const clientUserData ={
           clientUserId:row.id,
           updatedBy: storeUser.email,
       }
      const response = await axiosInstance.post(`${handleResendEmailForPwdReset}`,
        JSON.stringify(clientUserData)
      );
    if(response.data.Message){
        const msg = response.data.Message;
            if (msg !== "") {
              setRefreshMsg(msg);
              fetchClientUsersList("All", 0);
              setRefreshOpen(true);
            }
            else {
              setRefreshOpen(false);
            }
        }
        else{
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      setloading(false);
      console.log(error);
    }
  }

  const handleResetClick = async() =>{
    try{
    setSearchField("");
    setRstPagination(!resetPagination)
    //setDefaultCarefacilityId(-1);
    setloading(true);
    const resp = await axiosInstance.get(`${getClientUsersList}`);
        if(resp.data.isSuccess){
          fetchCareFacilityDetails("reset");
          setRecords(resp.data.result);
          setOriginalData(resp.data.result);
          setClientUsers(resp.data.result);
        }
        else if(!resp.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    }
    catch(err) {
      setloading(false);
      seterrormodalOpen(true);
      console.log(err.message);
    }
  }

  const handleChangeSearchText = (e) =>{
    setRstPagination(!resetPagination);
    setSearchField(e.target.value);
    let searchValue = false ;
    let id = false ;
		let userName = false ;
    let firstName = false ;
    let lastName = false ;
		let careFacilityName = false;
		let contactPerson = false ;
		let updatedBy = false;
		let updatedDate = false ;
		let emailVerificationStatus = false;
    

		const newdata = clientUsers.filter( row => {
      id = row.id && row.id.toString().includes(e.target.value.toString());
			userName = row.userName && row.userName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      firstName = row.firstName && row.firstName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      lastName = row.lastName && row.lastName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
			careFacilityName = row.careFacilityName && row.careFacilityName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      contactPerson = row.contactPerson && row.contactPerson.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      updatedBy = row.updatedBy && row.updatedBy.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      updatedDate = row.updatedDate && row.updatedDate.toString().includes(e.target.value.toString());
      emailVerificationStatus = row.emailVerificationStatus.toString().toLowerCase() && row.emailVerificationStatus.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
			
      if(id){
				searchValue = id
			}
			if(userName){
				searchValue = userName
			}
      else if(firstName){
				searchValue = firstName
			}
      else if(lastName){
				searchValue = lastName
			}
			else if(careFacilityName){
				searchValue = careFacilityName
			}
      else if(contactPerson){
				searchValue = contactPerson
			}
			else if(updatedBy){
				searchValue = updatedBy
			}
      else if(updatedDate){
				searchValue = updatedDate
			}
      else{
				searchValue = emailVerificationStatus
			}

			return searchValue;
    })
      setRecords(newdata);
      getClientUserIds(newdata);
  }

  const getClientUserIds =(data) =>{
    let list =[];
    data.map((row)=> list.push(row.id));
    setIdsListForDownload(list);
  }

  const checkCreatedDateOfUser =(createdOn)=>{
    const today= new Date();
    let createdDate = new Date(createdOn); 
    let dateCrossedThree = createdDate.setDate(createdDate.getDate()+ 3);
    let dateCrossedFive = createdDate.setDate(createdDate.getDate()+ 5); 
    //const diff = today.getDate() - createdDate.getDate();
    if(dateCrossedThree < today){
      if(today > dateCrossedThree && today < dateCrossedFive) {
        return "Expiration_Nearing"
      }
      // else if(today > dateCrossedFive) {
      //   return "Link_Expired"
      // }
      else
        return "Pending"
    }
  }

  const conditionalRowStyles = [
     {
         when: row =>row.emailVerificationStatus === "Verification Link Expired" && row.emailVerificationStatus !== "Active",
         style: {
          //animation: "blink-for-expired 1s infinite",
            backgroundColor: "#FFD6D7",
            color: "black",
            '&:hover':{
              backgroundColor: "#FFD6D7",
              color: "black",
            },
         }
     },
    {
      when: row =>((checkCreatedDateOfUser(row.createdDate) === "Expiration_Nearing" && row.emailVerificationStatus !== "Active")),
      style: {
        //animation: "blink-for-expNearing 1s infinite",
         backgroundColor: "#fffdaf",
         color: "black",
         '&:hover':{
           backgroundColor: "#fffdaf",
           color: "black",
         }
      }
  }
  ]

  return (
    <div>
      {loading && (
        <>
          <Backdrop
            sx={{
              color: "white",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
          >
            <CircularProgress sx={{ color: "white" }} />
            <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
          </Backdrop>
        </>
      )}
      
                 
      <div style={{ margin: "20px", borderTop: "none", alignItems: "center" }}>
      
        <ActiveCounts showNote={true}/>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: ".5rem",
          }}
        >
          <h2 className="header">Client User Listing</h2>
        </div>
        <Grid
          item
          sx={{
            p: "5px 16px",
            border: "1.5px solid #002d82",
            borderRadius: "5px",
            backgroundColor: "white",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            columnGap="1.5rem"
            justifyContent="center"
            sx={{ width: "100%", height: "65px", m: "5px 0" }}
          >
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="input-label">Care Facility</p>
              <TextField
                select
                id="care-facility-list"
                label=""
                value={careFacility}
                defaultValue="Select"
                variant="outlined"
                name="careFacility"
                onChange={onChangeFacility}
                sx={{ minWidth: "200px", "& .MuiInputBase-input":{padding:"9px 14px"}}}
                className="facility-account"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 200
                      },
                    },
                  },
                }}
              >
                {facilityRecords.map((option) => (                 
                  <MenuItem key={option.id} value={option.companyName}>
                    {option.companyName}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="input-label">Account Number</p>
              <TextField
                sx={{"& .MuiInputBase-input":{padding:"9px 14px"}}}
                variant="outlined"
                margin="none"
                label=""
                placeholder="Account Number"
                name="lastName"
                title={accountNum}
                value={maskedAccountId(accountNum)}
                inputProps={{ readOnly: true }}                
              ></TextField>
            </Box>
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                columnGap: "1rem"
              }}
            >
              
              <Button className="carefacility-rst-btn" variant="contained" onClick={handleResetClick}>
                  Reset
              </Button>
             
            </Box>
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            > 
                
                <TextField type="text" variant="outlined" 
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"30px !important"}} 
                    placeholder="Search"
                    value={searchField}
                        onChange={(e)=>handleChangeSearchText(e)}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'5px', paddingLeft: '5px', height: "40px", textAlign:"center"}
                        }} 
                    />
                </Box>
          </Stack>
        </Grid>
        <br></br>
        {/* <Stack
            direction="row"
            alignItems="center"
            columnGap="2rem"
            justifyContent="right"
            sx={{ width: "100%", height: "60px", m: "5px 0" }}
          >
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "right",
                justifyContent: "space-between",
              }}
            > 
                
                <TextField type="text" variant="outlined" 
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}} 
                    placeholder="Search"
                    value={searchField}
                        onChange={(e)=>handleChangeSearchText(e)}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'5px', paddingLeft: '5px', height: "40px", textAlign:"center"}
                        }} 
                    />
                </Box>
        </Stack> */}
        
        
        <DataTable
          title=""
          columns={careUsersColumns({ handleDelete, handleResendEmail, userAccessRole })}
          data={records}
          pagination
          striped
          highlightOnHover
          customStyles={customStyle}
          conditionalRowStyles={conditionalRowStyles}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          paginationResetDefaultPage={resetPagination}
          paginationPerPage={5}
          paginationComponentOptions={{
            rowsPerPageText: "Records per page",
            rangeSeparatorText: "Out of",
          }}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          expandableIcon={{
            collapsed: (
              <SvgIcon>
                <svg color="#002d82" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
                  />
                </svg>
              </SvgIcon>
            ),
            expanded: (
              <SvgIcon
                sx={{
                  color: "#002d82",
                }}
              >
                <svg viewBox="0 0 24 24" color="#002d82">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
                  />
                </svg>
              </SvgIcon>
            ),
          }}
        />
        
        <div className="button-container">
        <div className="left-btn-container">
        <Button
              id="back-btn"
              variant="outlined"
              onClick={() => {
                if(action == "view"){
                  navigate("/admin/careFacilityListings");
                }
                else
                navigate("/home");
              }}
            >
              {" "}
              Back
            </Button>
            {userAccessRole === "Admin" || userAccessRole === "Write" ? 
            <Button
              id="new-btn"
              variant="contained"
              onClick={() => {
                navigate("/admin/newClientUser", {
                  state: { careFacility: careFacility, accountNum: accountNum },
                });
              }}
            >
              Add New Client User
            </Button>
            : null}
        </div>
        <div>
        {records && records.length >0 ? 
        // <CustomExcelExport
				// 		filename={`CareFacilityUser-Listings.xlsx`}
				// 		data={userAndCareFacilityData}
				// 		headers={exportCareFacilityUserColumns}
        //     reportType={`client_user_listing`}
        //     method={getUserAndCfDataForDownload}
				// 		>
				// 	</CustomExcelExport>
          <Box
                  display="flex"
                  flexDirection="row"
                  sx={{ width: "350px", justifyContent: "right", textAlign:"right", float:"right" }}
                >
                  <Button className="resident-new-btn" variant="contained" onClick={getUserAndCfDataForDownload}>
                      Download
                  </Button>
          </Box>
        :""}
        </div>
        </div>

        <Modal open={open} onClose={() => setOpen(false)}>
          <Box sx={style}>
            <p>Are you sure you want to delete {userName} ?</p>
            <Box>
              <Button
                disabled={disableBtns}
                className="modal-con-yes-btn"
                variant="contained"
                onClick={handleDeleteClientUser}
              >
                Yes
              </Button>
              <Button
                disabled={disableBtns}
                className="modal-con-no-btn"
                variant="contained"
                onClick={() => {
                  setDisableBtns(true)
                  setOpen(false)
                }}
              >
                No
              </Button>
            </Box>
          </Box>
        </Modal>
        <Modal open={deleteOpen} onClose={handleDeleteClose}>
          <Box sx={style} style={{width:"25%"}}>
            <IconButton sx={{ border: "2px solid green", boxShadow: "none" }}>
              <Check sx={{ color: "green" }} />
            </IconButton>
            <p>Deleted successfully!</p>
            <Button
              id="modal-close-conf-btn"
              variant="contained"
              onClick={handleDeleteClose}
            >
              Close
            </Button>
          </Box>
        </Modal>
        <Modal open={refreshOpen} onClose={() => setRefreshOpen(false)}>
          <Box sx={style}>
            <p>{refreshMsg}</p>
            <Button
              id="modal-close-refresh-btn"
              variant="contained"
              onClick={() => setRefreshOpen(false)}
            >
              Close
            </Button>
          </Box>
        </Modal>
      </div>
      {errormodalopen && (
			<ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
		  )}
    </div>
  );
}

export default CareFacilityUsersListings;


const ExpandedComponent = ({ data }) => {
  const cfList = data.careFacilities && data.careFacilities.split(";")
  .map(item => item.split(" -")[0].split(":")[0] + " - " +
  item.split(" -")[1]);
  const cleanedList = cfList.map(item => {
    if(item.includes("(")){
      return item.split("(")[0] + "(" + item.split("(")[1].split(":")[0] + ")"
    }
    else return item
  })
  

  return (
    <div
      style={{
        display: "grid",
        gridAutoFlow: "row",
        gap: "10px",
        padding: "20px",
      }}
    >
      <label style={{ fontWeight: "bold", color: "#002d82", fontSize: "15px" }}>
       Care Facilities
      </label>

      <div
        style={{
          display: "grid",
          gridAutoFlow: "row",
          gap: "10px",
          padding: "20px",
          color: "#002d82",
          backgroundColor: "#f2f2f2",
          fontSize: "14px"
        }}
      >
        {cleanedList.map((carefacility, index) => (
            <span key={index}> {carefacility}</span>
          ))}
      </div>      
    </div>
  );
};